<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Sinh mã CODE</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="10">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="course_id" label="Khóa học cần sinh mã CODE" class="form-item">
              <el-select v-model="modelData.course_id" filterable clearable placeholder="Khóa học" class="input-select">
                <el-option
                  v-for="item in lists.listCourse"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="quantity" label="Số lượng mã CODE" class="form-item">
              <el-input type="age" v-model.number="modelData.quantity" class="input-seach" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'GenereCode',
  metaInfo () {
    return {
      title: 'Bán sách | Thêm'
    }
  },
  components: {

  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        course_id: '',
        quantity: 2
      },
      lists: {
        listCourse: [
          {key: 0, value: 'Chọn khóa học'}
        ],
        listUser: [
          {key: 0, value: 'Chọn học viên'}
        ]
      },
      rules: {
        course_id: [
          { required: true, message: 'Vui lòng nhập khóa học' }
        ],
        quantity: [
          { required: true, message: 'Vui lòng nhập học viên bạn muốn cho phép học danh sách học này' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchListCourse()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'bookings-index', text: 'Khóa học' },
        { name: 'bookings-create', text: 'Sinh mã CODE' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'bookings-index'})
    },
    // Fetch dữ liệu về lĩnh vực danh sách khóa học
    fetchListCourse () {
      axios.get('courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      console.log(this.modelData)
      axios.post('bookings/generate-code', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Sinh mã CODE thành công',
              type: 'success'
            })
            this.$router.push({name: 'bookings-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/bookings/Create.vue